exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.gap-1[data-v-2be4151b] {\n\tgap: 5px;\n}\n#unit-settings-button[data-v-2be4151b] {\n\tbackground-color: #126782ad;\n\tborder-color: #126782ad;\n}\n#unit-settings-button[data-v-2be4151b]:hover {\n\tbackground-color: #0b4d61ad;\n}\n", ""]);

// exports
